import React from 'react'

import ArrowRitght from '@icons/ArrowRight'
import RequestForm from '@src/components/RequestForm'

import * as style from './style.module.sass'

const ArticleRequest: React.FC = () => {
  const [shown, setShown] = React.useState(false)

  const handleClick = () => {
    setShown(true)
  }

  return (
    <>
      <button className={style.container} onClick={handleClick}>
        <div>
          <div className={style.title}>
            取材<span>&amp;</span>記事リクエスト
          </div>
          <p className={style.description}>
            ファッションテック領域で気になる人物、情報、ブランド、アイテムなどはありますか？
          </p>
        </div>
        <div className={style.arrow}>
          <ArrowRitght />
        </div>
      </button>
      {shown && (
        <RequestForm
          close={() => {
            setShown(false)
          }}
        />
      )}
    </>
  )
}

export default ArticleRequest
